<script setup>
import { useRoute } from 'vue-router/composables';
import { onMounted, reactive, toRefs, watch } from 'vue';
import { articleDetail } from '@/api/index';
import moment from 'moment';
const route = useRoute();

const state = reactive({
    detail: {}
});

const { detail } = toRefs(state);

const getDetail = () => {
    articleDetail({
        id: route.query?.id
    }).then(data => {
        if (data) {
            const date = data.data?.createTime || data.createTime
            state.detail = {
                ...data.data,
                timeDate: date ? moment(date).format('YYYY年MM月DD日') : ''
            };
            document.title = state.detail.title;
        }

    });
};

onMounted(() => {
    // 获取详情
    getDetail();

});

watch(() => route.query.id, () => {
    getDetail();

});
</script>

<template>
    <div class="wrap">
        <div class="wrap-box">
            <!-- <el-breadcrumb separator-class="el-icon-d-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/information' }">资讯</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb> -->


            <h1 class="font-style-s tc">{{detail.title}}</h1>
            <p class="date-text font-style-s">{{detail.timeDate}}</p>
            <div class="content font-style-s" >
                <div v-html="detail.content"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrap{
    background: #ffffff;
    padding: 44px 0 200px;
    .wrap-box{
        width: 1420px;
        margin: auto;

        ::v-deep .el-breadcrumb{
            color:#070707;
            font-size:18px;
        }
    }

    h1{
        font-weight:700;
        color:#333333;
        font-size:56px;
        margin-top: 65px;
        margin-bottom: 22px;
    }
    .date-text{
        margin-bottom: 95px;
        font-weight:700;
        color:#434343;
        font-size:24px;
        text-align: center;
    }
    .content{
        color:#3b3b3b;
        font-size:24px;

        ::v-deep img{
            max-width:100%;
        }
    }
}
</style>
